import SoftwareVersion from '../../models/enums/software-version';
import HttpError from '@common/interfaces/api/http-error';
import HttpFetchStatus from '@common/enums/api/http-fetch-status';
import Announcement from '../../models/service/announcements/announcement';
import MissionFilters from '../../models/service/stats/mission-filters';
import StatsMissionSet from '../../models/service/stats/mission-set';

interface ServiceState {
  missionStats: {
    entries: StatsMissionSet[];
    filters: MissionFilters;
  };
  announcements: {
    data: Announcement[] | null;
    seenAnnouncementIds: string[] | null;
    rest: {
      getStatus: HttpFetchStatus;
      getError: HttpError | null;
    };
  };
}

export const getInitialServiceState = (): ServiceState => {
  return {
    missionStats: {
      entries: [],
      filters: {
        softwareVersion: SoftwareVersion.Beta,
      },
    },
    announcements: {
      data: null,
      seenAnnouncementIds: null,
      rest: {
        getStatus: HttpFetchStatus.Idle,
        getError: null,
      },
    },
  };
};
export type { ServiceState };
